import { render, staticRenderFns } from "./CustomerDetails.vue?vue&type=template&id=f3f37698&"
import script from "./CustomerDetails.vue?vue&type=script&lang=js&"
export * from "./CustomerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QForm,QCardSection,QField,QCheckbox,QSelect,QInput,QCardActions,QBtn,QList,QExpansionItem,QItemSection,QTable,QSeparator} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QForm,QCardSection,QField,QCheckbox,QSelect,QInput,QCardActions,QBtn,QList,QExpansionItem,QItemSection,QTable,QSeparator})
